import { render } from "./AddEmployeeForm.vue?vue&type=template&id=45d270b3&scoped=true"
import script from "./AddEmployeeForm.vue?vue&type=script&lang=js"
export * from "./AddEmployeeForm.vue?vue&type=script&lang=js"

import "./AddEmployeeForm.vue?vue&type=style&index=0&id=45d270b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45d270b3"

export default script